const customAddToCart = async function (event, preorderDate, productHandle) {
  setAddToCartButtonState(true);
  if (productHandle == "boundless-bandana") {
    try {
      const form = event.target.closest(".product-form");
      const selectedBuyOption = form.getAttribute("data-selected-buy-option") || '1';
      if (!selectedBuyOption) throw new Error("Please select a buy option");
      // Get cart count for bundle ID
      const cartResult = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cart = await cartResult.json();
      let bundleCount = 0;
      if (cart && cart.items && Array.isArray(cart.items)) {
        bundleCount = cart.items.filter((item) => item.handle === "boundless-bandana").length;
      }
      let itemsToAdd = [];
      if (selectedBuyOption === "1") {
        const variantIdElement = document.querySelector("input[name='id']");
        const variantId = variantIdElement ? variantIdElement.value : null;
        const quantityElement = document.querySelector("input[name='quantity']");
        const quantity = quantityElement ? quantityElement.value || 1 : 1;
        bundleCount++;
        itemsToAdd.push({
          quantity: quantity,
          id: variantId,
          properties: {
            "_bandana-bundle-id": String(bundleCount),
            ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
          },
        });
      } else {
        const selectedVariantIds = [];
        const variantSelectors = document.querySelectorAll(
          `.variant-selectors[data-buy-option="${selectedBuyOption}"] .variant-selector`
        );
        variantSelectors.forEach((selector) => {
          const variantId = selector.getAttribute("data-selected-variant-id");
          if (variantId) selectedVariantIds.push(variantId);
        });
        const expectedVariantCount = parseInt(selectedBuyOption);
        if (selectedVariantIds.length !== expectedVariantCount) {
          throw new Error(
            `Please select ${expectedVariantCount} bandana${expectedVariantCount > 1 ? "s" : ""}`
          );
        }
        selectedVariantIds.forEach((variantId) => {
          bundleCount++;
          itemsToAdd.push({
            quantity: 1,
            id: variantId,
            properties: {
              "_bandana-bundle-id": String(bundleCount),
              ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
            },
          });
        });
      }
      for (const item of itemsToAdd) {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        if (!response.ok) {
          const responseJson = await response.json();
          throw new Error(responseJson["description"] || "Failed to add item to cart");
        }
      }
      await updateCartAndNotify(true);
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false);
    }
  } else {
    try {
      const variantIdElement = document.querySelector("input[name='id']");
      const variantId = variantIdElement ? variantIdElement.value : null;
      const quantityElement = document.querySelector("input[name='quantity']");
      const quantity = quantityElement ? quantityElement.value || 1 : 1;
      let body = { quantity: quantity, id: variantId };
      if (preorderDate) {
        body.properties = { "_preorder-date": preorderDate };
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const responseJson = await response.json();
      await updateCartAndNotify(response.ok, responseJson["description"] || "", responseJson);
      if (response.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items")
                ? responseJson["items"][0]
                : responseJson,
            },
          })
        );
      }
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false);
    }
  }
};

// Helper to set Add to Cart button state
function setAddToCartButtonState(loading) {
  const addToCartButton = document.getElementById("AddToCart");
  if (!addToCartButton) return;
  if (loading) {
    addToCartButton.setAttribute("disabled", "true");
    addToCartButton.setAttribute("aria-busy", "true");
  } else {
    addToCartButton.removeAttribute("disabled");
    addToCartButton.setAttribute("aria-busy", "false");
  }
}

// Helper to update cart and dispatch events
async function updateCartAndNotify(success, errorMsg, responseJson) {
  if (success) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }
    // Refresh cart and dispatch events
    const cartResponse = await fetch(
      `${window.themeVariables.routes.cartUrl}.js`
    );
    const cartContent = await cartResponse.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartContent },
      })
    );
    if (responseJson && responseJson["sections"]) {
      cartContent["sections"] = responseJson["sections"];
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer",
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "success",
          error: "",
        },
      })
    );
  } else {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "error",
          error: errorMsg,
        },
      })
    );
  }
}

var DidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("did-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(DidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("did-product-list", DidProductList);

var DidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
  }

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );

          Array.from(
            swatchGroup.querySelectorAll(".color-swatch__item")
          ).forEach((swatch) => {
            swatch.classList.remove("is-selected");
          });
          target.classList.add("is-selected");
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    let matchingVariant = null;

    matchingVariant = variants.find(function (variant) {
      return (
        variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
        variant.option2 === selectedValues[Object.keys(selectedValues)[1]] &&
        variant.option3 === selectedValues[Object.keys(selectedValues)[2]]
      );
    });

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
          variant.option2 === selectedValues[Object.keys(selectedValues)[1]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants[0];
    }

    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });
    if (target.hasAttribute("data-upsell-item")) {
      updateUpsellInfoWithProductAndVariantId(this.id, matchingVariantId);
    }
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => {
        const variantId = image.getAttribute("data-variant-id");

        return variantId === matchingVariantId.toString();
      });
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete
        ? Promise.resolve()
        : new Promise((resolve) => (newImage.onload = resolve));
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      let properties = {};
      if (
        Array.from(newImage.parentElement.classList).some((item) =>
          [
            "aspect-ratio--short",
            "aspect-ratio--tall",
            "aspect-ratio--square",
          ].includes(item)
        )
      ) {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1,
          },
        ];
      } else {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1,
          },
        ];
      }
      await newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out",
      }).finished;
      this.primaryImageList
        .filter(
          (image) =>
            image.classList.contains("product-item__primary-image") &&
            image !== newImage
        )
        .forEach((image) => image.setAttribute("hidden", ""));
    }
  }
  _onColorSwatchHovered(event, target) {
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find(
        (image) =>
          image.getAttribute("data-media-id") ===
          target.getAttribute("data-variant-featured-media")
      );
      if (newImage) {
        newImage.setAttribute("loading", "eager");
      }
    }
  }
};
window.customElements.define("did-product-item", DidProductItem);

function smoothScrollTo(event, targetId) {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
  }
}

// js/custom-element/ui/rid-native-video.js
var RidNativeVideo = class extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      this.play();
    } else {
      this.addEventListener("click", this.play.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video")
      .play()
      .then(() => {})
      .catch((error) => {
        console.error("Error playing video", error);
        this._showHideEnabledDisabledAutoplaySections();
      });
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  _showHideEnabledDisabledAutoplaySections() {
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 740;
    const sectionId = this.getAttribute("data-section-id");

    // Helper function to find sections by pattern
    const findSections = (pattern) => {
      const enabled = document.getElementById(
        `video-banner-autoplay-enabled-section-${pattern}-${sectionId}`
      );
      const disabled = document.getElementById(
        `video-banner-autoplay-disabled-section-${pattern}-${sectionId}`
      );
      return { enabled, disabled };
    };

    // Try to find sections in order of specificity
    const sections =
      findSections(isMobile ? "mobile" : "desktop") || // Try device-specific first
      findSections(""); // Fall back to generic sections

    if (!sections || !sections.enabled || !sections.disabled) {
      console.error("Autoplay sections not found for section ID:", sectionId);
      return;
    }

    // Hide enabled section and show disabled section
    sections.enabled.style.display = "none";
    sections.disabled.style.display = "block";
  }

  _replaceContent() {
    let node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    this.firstElementChild.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    this.firstElementChild.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("rid-native-video", RidNativeVideo);
var RidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("rid-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }

  attributeChangedCallback(name) {
    if (name === "hidden") {
      if (this.staggerApparition && !this.hidden) {
        this._staggerProductsApparition();
      }
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }

  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }

  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(RidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("rid-product-list", RidProductList);

var RidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );
    
    this.currentAnimation = null;

    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );
  }

  _updateSwatchAvailability = function (
    bandVariants,
    selectedValues,
    matchingVariant,
    width = null
  ) {
    if (!bandVariants) return;
    let bandVariantsArr;
    try {
      bandVariantsArr = JSON.parse(bandVariants);
    } catch (e) {
      console.error("Failed to parse bandVariants", e);
      return;
    }

    if (width)  {
      bandVariantsArr = bandVariantsArr.filter((variant) => {
        return (
          variant.option1 === width ||
          variant.option2 === width ||
          variant.option3 === width
        );
      });
      if (bandVariantsArr.length === 0) {
        console.warn("No band variants found for width:", width);
        return;
      }
    }

    const colorSwatchGroup = this.querySelector(
      '.swatch-group-wrapper[data-option-title="Color"]'
    );
    if (!colorSwatchGroup) return;

    colorSwatchGroup
      .querySelectorAll(".color-swatch__item")
      .forEach((swatch) => {
        const swatchValue = swatch.getAttribute("value");
        const swatchContainer = swatch.parentElement;
        const match = bandVariantsArr.find(
          (variant) =>
            variant.option1 === swatchValue ||
            variant.option2 === swatchValue ||
            variant.option3 === swatchValue
        );
        if (match && !match.available) {
          swatchContainer.classList.add("rid-product-item-swatch__unavailable");
        } else {
          swatchContainer.classList.remove("rid-product-item-swatch__unavailable");
        }
      });
  };

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    let bandVariants = product.getAttribute("data-band-product-variants");
    let triggersAvailabilityCheck = false;
      // target.getAttribute("triggers_availability_check") === "true" &&
      // !!bandVariants;

    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    const swatchGroup = target.closest(".swatch-group-wrapper");

    if (swatchGroup) {
      swatchGroup.setAttribute(
        "data-selected-value",
        target.getAttribute("value")
      );

      swatchGroup
        .querySelectorAll(".color-swatch__item, .block-swatch__item")
        .forEach((swatch) => {
          swatch.classList.remove("is-selected");
        });

      target.classList.add("is-selected");
      const input = target.closest('.color-swatch, .block-swatch')?.querySelector('input');
      if (input) {
        input.checked = true;
        input.focus();
      }
    }

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );

    let matchingVariant = null;

    matchingVariant = variants.find(function (variant) {
      return (
        variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
        variant.option2 === selectedValues[Object.keys(selectedValues)[1]] &&
        variant.option3 === selectedValues[Object.keys(selectedValues)[2]]
      );
    });

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
          variant.option2 === selectedValues[Object.keys(selectedValues)[1]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants[0];
    }

    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    this.setAttribute("data-selected-variant-id", matchingVariantId);

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });

    if (target.hasAttribute("data-variant-featured-media")) {
      if (this.currentAnimation) {
        this.currentAnimation.cancel();
        this.currentAnimation = null;
      }
      
      const newImage = this.primaryImageList.find((image) => {
        const variantId = image.getAttribute("data-variant-id");
        return variantId === matchingVariantId.toString();
      });

      if (!newImage) {
        console.warn("No matching image found for variant ID:", matchingVariantId);
        return;
      }
      
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete
        ? Promise.resolve()
        : new Promise((resolve) => (newImage.onload = resolve));
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      let properties = {};
      if (
        Array.from(newImage.parentElement.classList).some((item) =>
          [
            "aspect-ratio--short",
            "aspect-ratio--tall",
            "aspect-ratio--square",
          ].includes(item)
        )
      ) {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1,
          },
        ];
      } else {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1,
          },
        ];
      }
      
      this.currentAnimation = newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out",
      });
      
      try {
        await this.currentAnimation.finished;
      } catch {
        // Animation was cancelled - this is expected when clicking rapidly
      }
      
      this.primaryImageList
        .filter(
          (image) =>
            image.classList.contains("product-item__primary-image") &&
            image !== newImage
        )
        .forEach((image) => image.setAttribute("hidden", ""));
      triggersAvailabilityCheck &&
        this._updateSwatchAvailability(
          bandVariants,
          selectedValues,
          matchingVariant,
          target.getAttribute("value")
        );
    }
  }
};
window.customElements.define("rid-product-item", RidProductItem);


// js/custom-element/ui/rid-order-now.js
var RidOrderNow = class extends HTMLElement {
  constructor() {
    super();
    this.preorderDate = this.getAttribute('data-pre-order-date');
    this.orderNowTextData = document.getElementById('order-now-text-data');
    this.presetText = this.orderNowTextData?.getAttribute('data-order-now-text');
    this.init();
  }

  async init() {
    // Find both text elements - we need to handle both regular and mini-cart versions
    this.textElements = [
      this.querySelector('#order-now-snippet-text'),
      this.querySelector('#order-now-mini-cart-snippet-text')
    ].filter(Boolean); // Remove any null elements

    if (this.textElements.length === 0) {
      console.error('No order now text elements found');
      return;
    }

    if (this.preorderDate) {
      this.handlePreorderDate();
    } else if (this.presetText) {
      this.handlePresetText();
    } else {
      await this.handleDynamicShipping();
    }
  }

  handlePreorderDate() {
    const [year, month, day] = this.preorderDate.split('-');
    const dateObj = new Date(year, month - 1, day);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', options);

    const text = `Order now and it ships <b>${formattedDate}.</b>`;
    this.updateAllTextElements(text);
    
    const fastMessage = this.querySelector('#get-it-fast-message');
    if (fastMessage) {
      fastMessage.style.display = 'none';
    }
    
    this.style.visibility = 'visible';
  }

  handlePresetText() {
    this.updateAllTextElements(this.presetText);
    this.style.visibility = 'visible';
  }

  async handleDynamicShipping() {
    try {
      const response = await fetch('/pages/shipping_date_v2.json');
      const responseJson = await response.json();
      const data = JSON.parse(responseJson.page.body_html.replace(/'/g, '"'));

      const now = new Date();
      const cutoffDateTime = new Date(data.cutoffDateTime);
      let shipsWhen;
      let expectedShipDate;

      if (now < cutoffDateTime) {
        expectedShipDate = new Date(data.preCutoffShipDate);
      } else {
        expectedShipDate = new Date(data.postCutoffShipDate);
      }

      const normalizeDate = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      };

      const normalizedExpectedShipDate = normalizeDate(expectedShipDate);
      const normalizedNow = normalizeDate(now);
      const dayDifference = Math.ceil((normalizedExpectedShipDate - normalizedNow) / (1000 * 60 * 60 * 24));

      if (dayDifference === 0) {
        shipsWhen = 'today';
      } else if (dayDifference === 1) {
        shipsWhen = 'tomorrow';
      } else if (dayDifference > 6) {
        shipsWhen = `in ${dayDifference} days`;
      } else {
        shipsWhen = expectedShipDate.toLocaleString('en-US', { weekday: 'long' });
      }

      const timeDifferenceMs = cutoffDateTime - now;
      const remainingHours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
      const remainingMinutes = Math.floor((timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60));
      const isDeadlineApproaching = remainingHours < 6;

      let text = isDeadlineApproaching === false
        ? `Order <b>now</b> and it ships <b>${shipsWhen}!</b>`
        : remainingHours > 0 || remainingMinutes > 0
        ? `Order within <b>${
            remainingHours > 0 ? `${remainingHours} ${remainingHours === 1 ? 'hour' : 'hours'}` : ''
          } ${
            remainingMinutes > 0 ? `${remainingMinutes} ${remainingMinutes === 1 ? 'minute' : 'minutes'}` : ''
          }</b> and it ships <b>${shipsWhen}!</b>`
        : `Order now and it ships <b>${shipsWhen}!</b>`;

      if (this.orderNowTextData) {
        this.orderNowTextData.setAttribute('data-order-now-text', text);
      }

      this.updateAllTextElements(text);
      this.style.visibility = 'visible';
    } catch (e) {
      console.error('Error fetching shipping information:', e);
    }
  }

  updateAllTextElements(text) {
    this.textElements.forEach(element => {
      element.innerHTML = text;
    });
  }
};

window.customElements.define("rid-order-now", RidOrderNow);